import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { LoadingContainer } from "../../components/loading-container";
import { ServerError } from "../../types/server-error";
import { isValidationError } from "../../utils/axios-utils";
import { useJotForm } from "./queries";

export function JotForm() {
    const { id } = useParams<{ id: string }>();
    const { data, isLoading, isError, error } = useJotForm(id!);
    const [errorText, setErrorText] = useState<string>();

    useEffect(() => {
        if (isError) {
            if (isValidationError<ServerError>(error)) {
                setErrorText(error.data.errors.base.join(","));
            }
        }
    }, [isError, error]);

    return (
        <div className="index-jot-form">
            {isLoading && <LoadingContainer />}
            {errorText && <Alert variant="warning">{errorText}</Alert>}
            {data && data.url && (
                <iframe
                    id="myFrame"
                    src={data.url}
                    title="jotform"
                    allowFullScreen
                    allow="geolocation; microphone; camera"
                    frameBorder="0"
                    height="100%"
                    className="min-width-100p height-100p border-none"
                />
            )}
        </div>
    );
}
